import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import { CHAT_PART } from 'actions/chat';
import { WEB_RTC_FEATURES } from 'actions/chat/webrtc';
import { WEB_RTC_DEVICE_KIND } from 'reducers/chat/webrtc';
import autobind from 'autobind-decorator';
import '../styles/video.scss';

// Don't mess with this component if you don't have advanced knowledge on how React works
// The div elements that will be used by the Tokbox library cannot be updated
// because they're mutated.

class VideoChat extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    mode: PropTypes.string,
    canPublishVideo: PropTypes.bool.isRequired,
    webRTCSubscriberConfiguration: PropTypes.object,
    webRTCPublisherConfiguration: PropTypes.object,
    devices: PropTypes.arrayOf(PropTypes.object),
    mainVideoDisplay: PropTypes.string,
    disableCameraSwitch: PropTypes.bool.isRequired,
    twoDisplays: PropTypes.bool.isRequired,
    onEndWebRTC: PropTypes.func.isRequired,
    onSwitchCamera: PropTypes.func.isRequired
  };
  static VIDEO_SIZE = {
    verysmall: 'video/size/verysmall',
    small: 'video/size/small',
    medium: 'video/size/medium',
  };
  static isWideResolution(size, height) {
    let max;
    let min;

    switch (size) {
      case VideoChat.VIDEO_SIZE.verysmall:
        max = 240;
        min = 180;
        break;
      case VideoChat.VIDEO_SIZE.small:
        max = 480;
        min = 360;
        break;
      case VideoChat.VIDEO_SIZE.medium:
        max = 960;
        min = 720;
        break;
      default:
        max = 960;
        min = 720;
        break;
    }

    return Math.abs(max - height) < Math.abs(min - height);
  }
  static videoResolution(width, height) {
    if (width >= 1280) {
      return VideoChat.isWideResolution(VideoChat.VIDEO_SIZE.medium, height)
        ? '1280x960' : '1280x720';
    } else if (width >= 640) {
      return VideoChat.isWideResolution(VideoChat.VIDEO_SIZE.small, height)
        ? '640x480' : '640x360';
    }
    return VideoChat.isWideResolution(VideoChat.VIDEO_SIZE.verysmall, height)
        ? '320x240' : '320x180';

  }
  constructor(props) {
    super(props);

    let mainDisplay;

    if (this.props.mode !== WEB_RTC_FEATURES.audioOnly) {
      mainDisplay = this.props.mode === WEB_RTC_FEATURES.oneWayVideo
        ? CHAT_PART.agent : this.props.mainVideoDisplay;
    }

    this.state = {
      mutatedMainDisplay: mainDisplay,
      switchingCameras: false,
      alternateDevice: false,
      mainDisplay,
    };
  }

  get videoCustomerRendering() {
    if (this.props.mode !== WEB_RTC_FEATURES.twoWayVideo || !this.props.canPublishVideo) {
      return { display: 'none' };
    }

    if (this.state.mainDisplay === CHAT_PART.customer) {
      return {
        width: this.props.webRTCSubscriberConfiguration.width,
        height: this.props.webRTCSubscriberConfiguration.height,
      };
    }
    return {
      width: this.props.webRTCPublisherConfiguration.width,
      height: this.props.webRTCPublisherConfiguration.height,
    };

  }
  get videoAgentRendering() {
    if (this.state.mainDisplay === CHAT_PART.agent) {
      return {
        width: this.props.webRTCSubscriberConfiguration.width,
        height: this.props.webRTCSubscriberConfiguration.height,
      };
    }
    return {
      width: this.props.webRTCPublisherConfiguration.width,
      height: this.props.webRTCPublisherConfiguration.height,
    };

  }
  get switchScreenRendering() {
    return { bottom: `${parseInt(this.props.webRTCPublisherConfiguration.height, 10) + 10}px` };
  }
  get videoDevices() {
    return this.props.devices.filter(d => d.kind === WEB_RTC_DEVICE_KIND.input.video);
  }
  @autobind
  switchScreen() {
    if (this.state.mutatedMainDisplay === CHAT_PART.agent) {
      this.customerDisplay.classList.remove('secondary');
      this.agentDisplay.classList.add('secondary');
      this.agentDisplay.style.width = this.props.webRTCPublisherConfiguration.width;
      this.agentDisplay.style.height = this.props.webRTCPublisherConfiguration.height;
      this.customerDisplay.style.width = this.props.webRTCSubscriberConfiguration.width;
      this.customerDisplay.style.height = this.props.webRTCSubscriberConfiguration.height;
    } else {
      this.agentDisplay.classList.remove('secondary');
      this.customerDisplay.classList.add('secondary');
      this.agentDisplay.style.width = this.props.webRTCSubscriberConfiguration.width;
      this.agentDisplay.style.height = this.props.webRTCSubscriberConfiguration.height;
      this.customerDisplay.style.width = this.props.webRTCPublisherConfiguration.width;
      this.customerDisplay.style.height = this.props.webRTCPublisherConfiguration.height;
    }
    this.setState({ mutatedMainDisplay: this.state.mutatedMainDisplay === CHAT_PART.customer ? CHAT_PART.agent : CHAT_PART.customer });
  }
  @autobind
  switchCamera() {
    this.props.onSwitchCamera();
  }
  render() {
    return (
      <div className="chat-video-wraper">
        <div
          id="chat-webtrc-agent"
          style={this.videoAgentRendering}
          ref={(c) => { this.agentDisplay = c; }}
          className={this.state.mainDisplay !== CHAT_PART.agent ? 'secondary' : undefined}
         />
        <div
          id="chat-webtrc-customer"
          style={this.videoCustomerRendering}
          ref={(c) => { this.customerDisplay = c; }}
          className={this.state.mainDisplay !== CHAT_PART.customer ? 'secondary' : undefined}
         />
        <B.Button onClick={this.props.onEndWebRTC} bsStyle="danger" className="chat-video-btn chat-video-end">
          <B.Glyphicon glyph="remove" />
        </B.Button>
        {
          this.props.mode === WEB_RTC_FEATURES.twoWayVideo
            && !this.props.loading
            && this.props.twoDisplays ? (
              <B.Button
                onClick={this.switchScreen} bsStyle="primary"
                className="chat-video-btn chat-video-switchscreen"
                style={this.switchScreenRendering}
              >
                <B.Glyphicon glyph="new-window" />
              </B.Button>
          ) : undefined
        }
        {
          !this.props.disableCameraSwitch && this.videoDevices && this.videoDevices.length > 1 ? (
            <B.Button
              className="chat-video-btn chat-video-switchcamera"
              onClick={this.switchCamera}
              bsStyle="primary"
            >
              <B.Glyphicon glyph="camera" className="chat-video-switchcamera-camera" />
              <B.Glyphicon glyph="refresh" className="chat-video-switchcamera-rotate" />
            </B.Button>
          ) : undefined
        }
      </div>
    );
  }
}

export default VideoChat;



// WEBPACK FOOTER //
// ./components/chat/webrtc/video.js